import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useAccount } from 'wagmi'
import { IPFStoURL, formatPrice, getCurrentChain, getSaleCurrencyImg, getWeb3 } from '../helper/functions';
import { CHAIN_INFO, SUPPORTED_CHAIN } from '../helper/constant';
import auctionAbi from '../abis/nftauction.json';
import tokenAbi from '../abis/token.json';
import { useToasts } from 'react-toast-notifications';
import { getContract, getMultiCall } from '../helper/contractHelper';
import "react-datepicker/dist/react-datepicker.css";
import { useEthersSigner } from '../stats/useEthersSigner';
import { parseEther, zeroAddress } from 'viem';
import { ethers } from 'ethers';
import { useSelector } from 'react-redux';

export default function BuyNowModal({ buyModal, setBuyModal, buyData, nftData, metadata }) {
    const { chainId, address } = useAccount();
    const currentChainId = getCurrentChain(chainId);
    const [salePrice, setSalePrice] = useState('');
    const [buyAmount, setBuyAmount] = useState(1);
    const { addToast, removeAllToasts } = useToasts();
    const signer = useEthersSigner({ chainId: currentChainId });
    const [loading, setLoading] = useState(false)
    const theme = useSelector((state) => state.user.theme);
    const web3 = getWeb3(currentChainId);
    const [approved, setApproved] = useState(0);
    const [balance, setBalance] = useState(0);
    const [totalCost, setTotalCost] = useState(0);


    const handleBuyNow = async (order_id = 0) => {
        try {
            setLoading(true);
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let auctionContract = getContract(auctionAbi, CHAIN_INFO[chainId].nft_auction, signer);
                    let tokenAmount = 0;
                    let values = 0;
                    if (buyData.ERC20Token === zeroAddress) {
                        values = buyData.saletype === "2" ? salePrice : parseFloat((buyData.price * buyAmount) / Math.pow(10, 18));

                    }
                    else {
                        tokenAmount = buyData.saletype === "2" ? salePrice : parseFloat((buyData.price * buyAmount) / Math.pow(10, 18));
                    }

                    let tx = await auctionContract.makeBid(
                        order_id,
                        ethers.utils.parseUnits(tokenAmount.toString(), 18),
                        buyAmount,
                        { 'from': address, value: parseEther(values.toString()) });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                                setLoading(false);
                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });
                                setLoading(false);

                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                    setLoading(false);
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
                setLoading(false);
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            setLoading(false);
            console.error(err.message);
        }
    }

    const handleCancel = async (order_id = 0) => {
        try {
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let auctionContract = getContract(auctionAbi, CHAIN_INFO[chainId].nft_auction, signer);
                    console.log(auctionContract)
                    let tx = await auctionContract.cancelSale(order_id, { 'from': address });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });

                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });

                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });

                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            console.error(err.message);
        }
    }

    const handleFinalizeAuction = async (order_id = 0) => {
        try {
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let auctionContract = getContract(auctionAbi, CHAIN_INFO[chainId].nft_auction, signer);
                    let tx = await auctionContract.completeAuction(order_id, { 'from': address });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });

                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });

                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });

                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            console.error(err.message);
        }
    }

    const handleBuyAmount = (amount) => {
        const patt = /^\d+\.{0,1}\d{0,6}$/;
        if (amount === '' || amount === 0) {
            setBuyAmount(0);
        }
        else if (patt.test(amount) && parseInt(buyAmount) > parseInt(buyData.left_amount)) {
            setBuyAmount(buyData.left_amount)
        }
        else if (patt.test(amount) && parseInt(buyAmount) <= parseInt(buyData.left_amount)) {

            setBuyAmount(amount);
        }
    }


    const handleApprove = async () => {
        try {
            setLoading(true);
            if (address) {
                if (chainId && SUPPORTED_CHAIN.includes(chainId)) {
                    let tokenContract = getContract(tokenAbi, buyData.currencyInfo.address, signer);
                    let values = ethers.utils.parseUnits('100000000000' ,buyData.currencyInfo.decimals);
        
                    let tx = await tokenContract.approve(
                        CHAIN_INFO[currentChainId].nft_auction,
                        values,
                        { 'from': address });

                    var interval = setInterval(async function () {
                        let web3 = getWeb3(currentChainId);
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                addToast('Transaction completed successfully.', { appearance: 'success', });
                                setLoading(false);
                            }
                            else if (response.status === false) {
                                addToast('error ! Your last transaction is failed.', { appearance: 'error', });
                                setLoading(false);
                            }
                            else {
                                addToast('error ! something went wrong.', { appearance: 'error', });
                                setLoading(false);

                            }
                        }
                    }, 5000);
                } else {
                    removeAllToasts();
                    addToast('Please switch chain to Base mainnet', { appearance: 'error' });
                    setLoading(false);
                }
            } else {
                removeAllToasts();
                addToast('Please connect wallet', { appearance: 'error' });
                setLoading(false);
            }
        } catch (err) {
            removeAllToasts();
            addToast(err.reason ? err.reason : err.message, { appearance: 'error' });
            setLoading(false);
            console.error(err.message);
        }
    }
    

    useEffect(() => {
        async function fetch() {

            let isApproved = 0;
            let currencyBalance = 0;
            try {
                if (buyData.currencyInfo.address === zeroAddress) {
                    currencyBalance = web3.utils.fromWei(await web3.eth.getBalance(address), 'ether');
                    isApproved = 100000000000000000000000;
                }
                else {
                    let tokenContract = new web3.eth.Contract(tokenAbi, buyData.currencyInfo.address);
                    let data = await getMultiCall([
                        tokenContract.methods.balanceOf(address),
                        tokenContract.methods.allowance(address, CHAIN_INFO[currentChainId].nft_auction)
                    ])

                    currencyBalance = parseFloat(data[0]) / Math.pow(10, buyData.currencyInfo.decimals);
                    isApproved = parseFloat(data[1]) / Math.pow(10, buyData.currencyInfo.decimals);
                }
            }
            catch (err) {
                console.log(err.message);
            }

            setApproved(isApproved);
            setBalance(currencyBalance);

        }
        if (address && buyData.currencyInfo && buyData.currencyInfo.address) {
            fetch()
        }
    }, [buyModal])

    useEffect(() => {
        buyData.price && buyAmount ? setTotalCost((buyData.price / Math.pow(10, 18)) * parseFloat(buyAmount)) : setTotalCost(0)
    }, [buyData, buyAmount , loading]);


    return (
        <>
            <Modal
                show={buyModal}
                onHide={() => setBuyModal(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className={`${theme}-scheme p-4`}

            >
                <Modal.Body >
                    <div className='d-flex justify-content-between'>
                        <h3>Buy NFT</h3>
                        <button onClick={() => setBuyModal(false)} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className='row d-flex justify-content-center'>
                        <div className='col-4'>
                            <img src={IPFStoURL(metadata?.['image'])} class="img-rounded mb-sm-30" height="100px" width="100px" alt="profile" />
                        </div>
                        <div className='col-5'>
                            <h5>{metadata?.['name']}</h5>
                            <h5>Token ID : {nftData && nftData.tokenId ? nftData.tokenId : ''}</h5>
                            <h5>QTY : {buyData.amount ? buyData.amount : ''}</h5>
                        </div>
                    </div>
                    <div class="p-3 form-border mt-4">
                        <div class="de_tab tab_simple">
                            <h6>Current Price</h6>
                            <div class="nft-item-price">
                                <img src={getSaleCurrencyImg(buyData.ERC20Token, currentChainId)} alt="ethereum" />
                                <span>{buyData && buyData.nftHighestBid > 0 ? buyData.nftHighestBid / Math.pow(10, 18) : buyData && buyData.price ? buyData.price / Math.pow(10, 18) : ' - '}</span>
                                <p>Listed By {buyData?.username}</p>
                            </div>
                        </div>
                        {buyData.saletype === '2' &&
                            <div className='row mb-4'>

                                <div className='col-12 col-md-12'>
                                    <h6>Bid Price</h6>
                                    <input type="text" onChange={(e) => setSalePrice(e.target.value)} name="sale_price" id="sale_price" class="form-control" value={salePrice} placeholder='Enter sale price' />
                                </div>

                            </div>
                        }
                        {buyData.nfttype === "2" && buyData.saletype === "1" && address && buyData.nftSeller && buyData.nftSeller.toLowerCase() !== address.toLowerCase() &&
                            <div className='row mb-4'>
                                <div className='col-12 text-center'>
                                    Your Balance : {formatPrice(balance)} {buyData.currencyInfo.symbol}
                                </div>
                                <div className='col-12 col-md-12 d-flex justify-content-center'>
                                    <div class="number counter">
                                        <span class="minus mx-2" onClick={() => handleBuyAmount(buyAmount > 1 ? buyAmount - 1 : 1)}>-</span>
                                        <input type="text" value={buyAmount} onChange={(e) => handleBuyAmount(e.target.value)} />
                                        <span class="plus mx-2" onClick={() => handleBuyAmount(buyAmount < buyData.left_amount ? buyAmount + 1 : buyAmount)}>+</span>
                                    </div>
                                </div>
                            </div>
                        }

                        {((address && buyData.nftSeller && buyData.nftSeller.toLowerCase() === address.toLowerCase()) || (address && buyData.nftHighestBidder && buyData.nftHighestBidder.toLowerCase() === address.toLowerCase())) ? (
                            <>
                                {
                                    buyData.nftHighestBidder !== zeroAddress && (
                                        <>
                                            {buyData.auctionEnd > 0 && Math.floor(new Date().getTime() / 1000.0) >= buyData.auctionEnd &&
                                                <p className='text-success'>* Auction Period is over , you can finalize the auction , Highest Bidder will get nft</p>
                                            }
                                            <button type="button" onClick={() => handleFinalizeAuction(buyData.order_id)} class="btn-main btn-fullwidth mb-3">
                                                Finalize Auction
                                            </button>
                                        </>
                                    )
                                }
                                {buyData.nftSeller && buyData.nftSeller.toLowerCase() === address.toLowerCase() &&
                                    <>
                                        {
                                            buyData.auctionEnd > 0 && Math.floor(new Date().getTime() / 1000.0) >= buyData.auctionEnd &&
                                            <p className='text-danger'>* Auction Period is over , you can cancel auction.</p>
                                        }
                                        < button type="button" onClick={() => handleCancel(buyData.order_id)} class="btn-main btn-fullwidth mb-3">
                                            Cancel Listing
                                        </button>
                                    </>
                                }



                            </>
                        ) : (

                            <div className='text-center'>
                                {buyData.saletype === "1" &&
                                    <p className='mb-2'>Total Cost : {formatPrice(totalCost)} {buyData.currencyInfo.symbol}</p>
                                }
                                {parseFloat(approved) > parseFloat(totalCost) ? (
                                    <button disabled={loading} type="button" onClick={() => handleBuyNow(buyData.order_id)} class="btn-main btn-fullwidth">
                                        {loading ? 'Loading...' : buyData.saletype === "2" ? "Place Bid" : 'Buy Now'}
                                    </button>
                                ) : (
                                    <button disabled={loading} type="button" onClick={() => handleApprove(buyData.order_id)} class="btn-main btn-fullwidth">
                                        {loading ? 'Loading...' : buyData.saletype === "2" ? "Place Bid" : 'Approve'}
                                    </button>
                                )}

                            </div>
                        )}


                    </div>
                </Modal.Body>

            </Modal >
        </>
    )
}
